<template>
  <div>
    <span v-for="item in options" :key="item.value" class="operation-item">
      <el-button v-if="!item.children" :disabled="item.disabled"  type="text" size="mini" @click="handleFirstLevelClick(item)">{{item.label}}</el-button>
      <el-dropdown v-else @command="handleCommand" trigger="click">
        <SvgIconHover
          style="font-size: 20px"
          svgIconClass="icon-operation-col-more"
          svgIconClassHover="icon-operation-col-more"
        ></SvgIconHover>
        <el-dropdown-menu slot="dropdown" class="hc-operation-col__popover">
          <el-dropdown-item v-for="child in item.children" :key="child.value" :command="child">{{child.label}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </div>
</template>

<script>
import SvgIconHover from '@/components/SvgIconHover.vue'

export default {
  name: 'HcOperationCol',
  components: {
    SvgIconHover
  },
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
  },
  emits: ['command'],
  methods: {
    emitCmd(item) {
      item.change && item.change()
      this.$emit('command', item.value)
    },
    handleFirstLevelClick(item) {
      this.emitCmd(item)
    },
    handleCommand(item) {
      this.emitCmd(item)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.operation-item + .operation-item {
  margin-left: 12px;
}

.hc-operation-col__popover.el-popper {
  // margin-top: 4px !important;
  // margin-bottom: 4px !important;
  padding: 4px 0px 4px 0px !important;

  .el-dropdown-menu__item {
    padding: 0 20px 0 20px;
    height: 32px;
    line-height: 32px;

    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: $main-color;

    // 居中
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
